import { useState } from 'react';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import { useDashboardDate } from '@/contexts/DashboardDateContext';
import { useDashboardDataSource } from '@/contexts/DashboardDataSourceContext';

export function AnalyticsExportButton() {
  const [busy,setBusy]=useState(false);
  const {startDate,endDate}=useDashboardDate();
  const {getUrl,sourceType}=useDashboardDataSource();
  async function exportReport(){
    setBusy(true);
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),30000);
    try {
      const res=await fetch(getUrl('export',new URLSearchParams({startDate,endDate})),{cache:'no-store',signal:controller.signal});
      if(!res.ok){const error=await res.json().catch(()=>null);throw new Error(error?.error||'Could not export this report');}
      if(!res.headers.get('content-type')?.includes('text/csv'))throw new Error('The export did not return a CSV report');
      const blob=await res.blob(),url=URL.createObjectURL(blob),link=document.createElement('a');
      link.href=url;link.download=`admoji-analytics-${startDate}-${endDate}.csv`;
      document.body.appendChild(link);link.click();link.remove();
      setTimeout(()=>URL.revokeObjectURL(url),1000);
      toast.success('Analytics export downloaded');
    }catch(error){toast.error(error instanceof Error?error.message:'Could not export this report');}
    finally{clearTimeout(timeout);setBusy(false);}
  }
  return <button type="button" onClick={exportReport} disabled={busy||sourceType!=='unified'}
    title={sourceType==='unified'?'Download daily ad metrics for the selected accounts, dates and attribution':'Select a connected account to export'}
    data-testid="canvas-analytics-export" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium disabled:opacity-50"
    style={{background:'#F7F9FC',border:'1px solid #e3e8ef',color:'#657084'}}>
    <Download size={13}/><span>{busy?'Exporting…':'Export'}</span>
  </button>;
}
